import type { HbBidderConfig } from '../types'

const BANNER_PLC = '10000733255'
const VIDEO_PLC = '10000733258'

export const INMOBI_BANNER: HbBidderConfig = {
    bidder: 'inmobi',
    params: {
        plc: BANNER_PLC,
    },
}

export const INMOBI_VIDEO: HbBidderConfig = {
    bidder: 'inmobi',
    params: {
        plc: VIDEO_PLC,
    },
}
